import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface AddShippingInfo extends GtagEvent {
    currency:ISO_4217;
    value: number;
    coupon?:string;
    shipping_tier?:string;
    items:Item[]
}
export const add_shipping_info = ($_:AddShippingInfo) => event('add_shipping_info',$_);